import { SortBy } from './types'
import type { Garage } from './types'

const getAvailabilityRank = (
    garage: Garage,
    laterAvailableGarageIds: ReadonlySet<number>,
): number => {
    if (garage.available) return 0
    if (laterAvailableGarageIds.has(garage.id)) return 1
    return 2
}

const compareByPrice = (a: Garage, b: Garage): number => {
    const priceA = a.amountCentsCzk
    const priceB = b.amountCentsCzk

    if (priceB === null && priceA === null) return 0
    if (priceB === null) return -1
    if (priceA === null) return 1
    if (priceB < priceA) return 1
    if (priceB > priceA) return -1
    return 0
}

export const sortGarageList = (
    garageList: Array<Garage>,
    sortBy: SortBy,
    laterAvailableGarageIds: ReadonlySet<number>,
): Array<Garage> => [...garageList].sort((a, b) => {
    const availabilityDifference =
        getAvailabilityRank(a, laterAvailableGarageIds) -
        getAvailabilityRank(b, laterAvailableGarageIds)

    if (availabilityDifference !== 0) return availabilityDifference

    return sortBy === SortBy.distance
        ? a.distance - b.distance
        : compareByPrice(a, b)
})
